module.exports = __webpack_public_path__ + "components/Game/Steps/Intruder/IntruderQuestionImage-1.ee3ccffd4bdb04c0be6ffdca71fbf0a3.jpg";